export default __webpack_public_path__ + "static/img-baker-mark-cuban-13d48f289d5f0b635b2a8ce1463480f1.png";